import { Component } from '@angular/core';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { GeoArea } from 'src/app/assabil-kernel/models/entities/control-tables/geo-area-entity';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';

@Component({
    selector: 'geo-area-lov',
    templateUrl: './geo-area-lov.component.html',
    styleUrls: ['./geo-area-lov.component.scss']
})


export class GeoAreaLovComponent extends GenericLovComponent   {


    code         : string; 
    name         : string; 

    geoAreas                 : GeoArea[] = [];

    columns = [
        {  prop: 'geoAreaCode', name: 'Code'},
        {  prop: 'name', name: 'Nom'}
    ]


//----------------------------------------------------------------------
constructor( 
    public dialogRef: MatDialogRef<GeoAreaLovComponent>,
    protected controlTablesService  : ControlTablesService) {
    super();
    this.entityName = "geoArea";
}
//----------------------------------------------------------------------
    


//----------------------------------------------------------------------
loadData() {
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlTablesService.getList(this.entityName, request).then(result => {
        this.geoAreas = result;
    })
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
closeModal(geoArea : GeoArea){
    this.dialogRef.close(geoArea);
}
//----------------------------------------------------------------------

}
